export default __webpack_public_path__ + "static/media/3435 knife block A side.2fdbf971.png";